import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.scoped.css';

export default function InfoNotice({ prefixText, provinceText }) {
  return (
    <div className={styles.infoNotice}>
      <span className={styles.infoNoticeIcon}>
        <svg
          aria-hidden="true"
          fill="none"
          height="20"
          viewBox="0 0 20 20"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" fill="#45A0FF" r="10" />
          <path
            d="M10 8.5V13"
            stroke="white"
            strokeLinecap="round"
            strokeWidth="1.75"
          />
          <circle cx="10" cy="6" fill="white" r="1" />
        </svg>
      </span>
      <span className={styles.infoNoticeText}>
        {prefixText} <strong>{provinceText}</strong>.
      </span>
    </div>
  );
}

InfoNotice.propTypes = {
  prefixText: PropTypes.string.isRequired,
  provinceText: PropTypes.string.isRequired,
};
